import React, { type MouseEvent, useState } from 'react';

import { type FPlatformUserFragment } from '@dashboard/generated/wp/authentication';
import { MoreHorizOutlined } from '@mui/icons-material';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';

import { useCurrentPlatformUser } from '../../../hooks';

import DeleteUserConfirmationDialog from './DeleteUserConfirmationDialog';

type Props = {
  platformUser: FPlatformUserFragment;
};
export default function ActionsMenu({ platformUser }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { data } = useCurrentPlatformUser();
  const open = Boolean(anchorEl);
  const handleClickAnchor = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const model = data?.currentPlatformUser;

  const renderDeleteUserConfirmationDialog = () => {
    if (!deleteModalOpen) {
      return null;
    }

    return <DeleteUserConfirmationDialog onClose={() => setDeleteModalOpen(false)} platformUser={platformUser} />;
  };

  const renderDeleteUserMenuItem = () => {
    if (model === undefined) {
      return renderDisabledButton('Loading permissions');
    }

    if (model.role === 'USER') {
      return renderDisabledButton('Insufficient permissions');
    }

    if (platformUser.isCurrentUser) {
      return renderDisabledButton(`You can't remove yourself`);
    }
    if (platformUser.role === 'OWNER') {
      return renderDisabledButton(`You can't remove owners`);
    }

    return (
      <div>
        <MenuItem
          sx={{ color: 'brand.red' }}
          onClick={() => {
            setAnchorEl(null);
            setDeleteModalOpen(true);
          }}
        >
          Remove team member
        </MenuItem>
      </div>
    );
  };

  return (
    <>
      <Tooltip title="More actions">
        <IconButton size="small" onClick={handleClickAnchor}>
          <MoreHorizOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        {renderDeleteUserMenuItem()}
      </Menu>
      {renderDeleteUserConfirmationDialog()}
    </>
  );
}

function renderDisabledButton(tooltip: string) {
  return (
    <Tooltip title={tooltip}>
      <div>
        <MenuItem disabled sx={{ color: 'brand.red' }}>
          Remove team member
        </MenuItem>
      </div>
    </Tooltip>
  );
}
